import React from 'react'
import PropTypes from 'prop-types'
import ExpansionPanelLib from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import Heading from '../Heading'
import Icon from '../Icon'

function ExpansionPanel({
  children, header, expandIcon, title, headerTextColor, expansionIconColor, editing,
}) {
  const [expanded, setExpanded] = React.useState(false)
  const handleChange = () => setExpanded(!expanded)
  return (
    <ExpansionPanelLib expanded={expanded || editing} onChange={handleChange}>
      <ExpansionPanelSummary
        expandIcon={editing ? null : expandIcon || <Icon iconName="ExpandMore" style={{ color: expansionIconColor }} />}
        style={{ display: 'inline-flex' }}
      >
        { header || <Heading level="h6" color={headerTextColor}>{ title }</Heading>}
      </ExpansionPanelSummary>
      <ExpansionPanelDetails>
        { children }
      </ExpansionPanelDetails>
    </ExpansionPanelLib>
  )
}

ExpansionPanel.defaultProps = {
  header: null,
  editing: false,
  expandIcon: null,
  expansionIconColor: '#000',
  headerTextColor: '#000',
  title: '',
}

ExpansionPanel.propTypes = {
  children: PropTypes.node.isRequired,
  editing: PropTypes.bool,
  expandIcon: PropTypes.element,
  header: PropTypes.element,
  headerTextColor: PropTypes.string,
  expansionIconColor: PropTypes.string,
  title: PropTypes.node,
}

export default ExpansionPanel
